import { isPrerender } from './is-prerender';

export const loadScript = async (src: string) => {
  if (isPrerender()) {
    return;
  }

  return new Promise<void>((resolve, reject) => {
    if (document.querySelector(`script[src*="${src}"]`)) {
      resolve();
    }

    const script = document.createElement('script');

    script.src = src;
    script.async = true;

    script.onload = (e) => {
      resolve();
    };

    script.onerror = (e) => {
      reject(e);
    };

    document.head.appendChild(script);
  });
};
